var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.228,
    height: 42.228,
    viewBox: "0 0 42.228 42.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(652.772 -59.637) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-400.05 484.39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379.05,494.891a10.512,10.512,0,0,0-10.5-10.5,10.512,10.512,0,0,0-10.5,10.5,10.519,10.519,0,0,0,6.812,9.832.128.128,0,0,0,0,.022v1.915a1.986,1.986,0,0,0,1.4,1.893l-.545,11.589c0,.046,0,.091,0,.137a2.833,2.833,0,0,0,2.832,2.831,2.833,2.833,0,0,0,2.831-2.968l-.545-11.589a1.986,1.986,0,0,0,1.4-1.893v-1.915a.125.125,0,0,0,0-.022A10.519,10.519,0,0,0-379.05,494.891Zm-10.5,7.609a7.618,7.618,0,0,1-7.609-7.609,7.617,7.617,0,0,1,7.609-7.609,7.617,7.617,0,0,1,7.608,7.609A7.618,7.618,0,0,1-389.549,502.5Z",
    transform: "translate(400.05 -484.39)",
    fill: "#6b85b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.bee1fb008fbf3095dee0573365fd8448.svg";
export { ForwardRef as ReactComponent };